import React, { useEffect } from 'react'
import './Seguridad.css'
import { useLocation } from "react-router-dom";
import Magnet from '../Magnet/Magnet'
import LazyVideo from '../LazyVideo/LazyVideo'


function Seguridad() {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
        }
    }, [location]);

    useEffect(() => {
        const els = document.querySelectorAll('.serv-card.reveal');
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
        els.forEach(el => io.observe(el));
        return () => io.disconnect();
    }, []);

    const items = [
        {
            num: '01',
            title: 'BÚSQUEDA Y RESCATE',
            desc: 'Utilización de cámaras térmicas que detecten patrones de calor, cubriendo extensas áreas, con posibilidad de proporcionar coordenadas precisas en tiempo real y superando cualquier dificultad que presente el terreno.',
            media: { type: 'video', src: '/media/incendios.mp4' }
        },
        {
            num: '02',
            title: 'INCENDIOS FORESTALES',
            desc: 'Se obtiene información aérea en tiempo real que permita una mejor toma de decisiones estratégicas, mejorando la conciencia situacional así como la asignación de recursos en el transcurso de la emergencia.',
            media: { type: 'image', src: '/media/incendio.webp', alt: 'incendio forestal' }
        }
    ];

    return (
        <div className='degradado safety-section'>
            <div className='safety-glow' />

            <div className="safety-stack">
                {items.map((item, i) => (
                    <article
                        key={item.num}
                        className={`serv-card reveal feat-card${i % 2 ? ' feat-card--rev' : ''}`}
                    >
                        <div className="serv-card__media">
                            {item.media.type === 'video' ? (
                                <LazyVideo src={item.media.src} className='serv-card__video' />
                            ) : (
                                <img src={item.media.src} alt={item.media.alt} loading="lazy" className='serv-card__img' />
                            )}
                        </div>
                        <div className="serv-card__body">
                            <span className="serv-card__num">{item.num} / 02</span>
                            <h3 className="serv-card__title">{item.title}</h3>
                            <p className="serv-card__desc">{item.desc}</p>
                        </div>
                    </article>
                ))}
            </div>

            <div className="espacio">
                <Magnet padding={30} disabled={false} magnetStrength={2} wrapperClassName='magneto' innerClassName='magnetoDos'>
                    <button onClick={() => window.location.href = "/#contacto"} className='cta'>
                        <span>CONTÁCTANOS</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </Magnet>
            </div>
        </div>
    )
}

export default Seguridad
